







































































































































































































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import SortIcons from '@/components/common/SortIcons.vue'
import AccountsTableRow from '@/components/accounts/AccountsTableRow.vue'
import { Accountext } from 'dapp-client'
const numeral = require('numeral')
const debounce = require('lodash.debounce')

@Component({
  components: {
    AccountsTableRow,
    SortIcons
  }
})
export default class AccountsTable extends Vue {
  @Prop() accounts!: Accountext[]
  @Prop() showAccount!: boolean
  @Prop() showActionBtn!: boolean
  private accountSearch: String = ''
  private searchOptions = {
    shouldSort: true,
    threshold: 0.3,
    location: 0,
    distance: 100,
    maxPatternLength: 12,
    minMatchCharLength: 1,
    keys: ['account']
  }
  searchResults: any = []
  private searchState: string = 'search'
  private numeral = numeral
  public debouncedGetSearch: any
  currentSort = 'balance'
  currentSortDir = 'desc'
  currentPage = 1
  limit = 10
  offset = 0

  get currentUser() {
    return vxm.transit.currentUser
  }

  get pages() {
    let count = 0
    if (this.searchResults.length) count = this.searchResults.length
    else count = this.accounts.length
    return Math.ceil(count / this.limit)
  }

  get searchedAccounts() {
    if (this.searchResults.length > 0)
      return this.searchResults.slice(this.offset, this.offset + this.limit)
    else return this.sortedAccounts
  }

  get sortedAccounts() {
    return this.accounts
      .sort((a: any, b: any) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (
          this.currentSort === 'account' ||
          this.currentSort === 'provider' ||
          this.currentSort === 'pending_package' ||
          this.currentSort === 'service' ||
          this.currentSort === 'status'
        ) {
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
          return 0
        } else {
          if (parseFloat(a[this.currentSort]) < parseFloat(b[this.currentSort]))
            return -1 * modifier
          if (parseFloat(a[this.currentSort]) > parseFloat(b[this.currentSort]))
            return 1 * modifier
          return 0
        }
      })
      .slice(this.offset, this.offset + this.limit)
  }

  setPagination(page: 'first' | 'last' | 'next' | 'prev') {
    if (page === 'first') {
      this.offset = 0
      this.currentPage = 1
    } else if (page === 'last') {
      this.offset = this.pages * this.limit - this.limit
      this.currentPage = this.pages
    } else if (page === 'next') {
      this.offset += this.limit
      this.currentPage++
    } else if (page === 'prev') {
      this.offset -= this.limit
      this.currentPage--
    }
  }

  isUser(account: string) {
    if (!this.currentUser) return false
    else if (this.currentUser.accountName === account) return true
  }

  sort(s: string) {
    if (s === this.currentSort) {
      this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
    }
    this.currentSort = s
  }

  searchAccounts() {
    // @ts-ignore
    this.$search(this.accountSearch, this.accounts, this.searchOptions).then(
      (results: any) => {
        this.searchResults = results
        if (this.accountSearch === '') this.searchState = 'search'
        else this.searchState = 'check'
      }
    )
  }

  @Watch('accountSearch')
  async onSearchChange(val: any, oldVal: any) {
    if (val !== '') {
      this.searchState = 'keyboard'
      this.debouncedGetSearch()
    } else {
      this.searchAccounts()
    }
  }

  // Lifecycle hooks
  mounted() {}
  created() {
    this.debouncedGetSearch = debounce(() => {
      this.searchAccounts()
    }, 500)
  }
  updated() {}
  destroyed() {}
}
